<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css" rel="stylesheet" />

<div class="col-12 mt-5" >
    <div class=" row">
    <div class="col-md-12 m-0 p-0">
      
             
       <div class="row  my-3 w-100 d-flex justify-content-between m-0"  >
        <!--<i class="col-md-3 fas fa-exclamation-circle fa-2x p-2" style="color:#f3b165;"></i>-->
        <div class="col-md-2 d-flex flex-column border my-1  p-2 shadow-sm border-black bg-white rounded p-1"><!--<span class="odometer" data-count={{salesRepresentativeCount}}></span>-->
         <div class="row justify-content-between mx-0">
             <div class="text-left "><i class="fas fa-angle-double-up text-success indicator" *ngIf="dailyCountDiff>0"  ><span class="mx-1" style="font-size: small;">{{dailyLoginDiff}}%</span></i> 
                 <i class="fas fa-angle-double-down text-danger indicator" *ngIf="dailyCountDiff<0" ><span class="mx-1" style="font-size: small;">{{dailyCountDiff}}%</span></i></div> 
         <div class="topsquarenumber text-primary" >{{dailycount}}</div>

        </div>
        <div class="topsquare text-primary   py-2   p-0 ">
            TODAYS COUNT</div>
        
        </div>


        <div class="col-md-2 d-flex flex-column border my-1  p-2 shadow-sm border-black bg-white rounded p-1"><!--<span class="odometer" data-count={{salesRepresentativeCount}}></span>-->
            <div class="row justify-content-between mx-0">
                <div class="text-left "><i class="fas fa-angle-double-up text-success indicator" *ngIf="weekCountDiff>0"  ><span class="mx-1" style="font-size: small;">{{weekCountDiff}}%</span></i> 
                    <i class="fas fa-angle-double-down text-danger indicator" *ngIf="weekCountDiff<0" ><span class="mx-1" style="font-size: small;">{{weekCountDiff}}%</span></i></div> 
            <div class="topsquarenumber text-primary" >{{currentweekcount}}</div>
   
           </div>
           <div class="topsquare text-primary   py-2   p-0 ">
               WEEK COUNT</div>
           
           </div>


    <!--<i class="col-md-3 fas fa-exclamation-circle fa-2x p-2" style="color:#f3b165;"></i>-->
    <div class="col-md-2  d-flex flex-column border my-1 p-2 shadow-sm border-black bg-white rounded p-1">
     <div class="row justify-content-between mx-0">
     <div class="text-left "><i class="fas fa-angle-double-up text-success indicator"  *ngIf="monthlyCountDiff>0" ><span class="mx-1" style="font-size: small;">{{monthlyCountDiff}}%</span></i> 
         <i class="fas fa-angle-double-down text-danger indicator" *ngIf="monthlyCountDiff<0" ><span class="mx-1" style="font-size: small;">{{monthlyCountDiff}}%</span></i></div>
        <a class="topsquarenumber text-success" >            {{currentmonthcount}}</a>

     </div>
    <div class="topsquare text-success  py-2   p-0 "
     >
        CURRENT MONTH COUNT</div>
    
    </div>

    



 <!--<i class="col-md-3 fas fa-exclamation-circle fa-2x p-2" style="color:#f3b165;"></i>-->
 <div class="col-md-2  d-flex flex-column border my-1 p-2 shadow-sm border-black bg-white rounded p-1">
     <div class="row justify-content-between mx-0">
         <div class="text-left "><i class="fas fa-angle-double-up text-success indicator" *ngIf="annualCountDiff>0" ><span class="mx-1" style="font-size: small;">{{annualCountDiff}}%</span></i> 
             <i class="fas fa-angle-double-down text-danger indicator" *ngIf="annualCountDiff<0" ><span class="mx-1" style="font-size: small;">{{annualCountDiff}}%</span></i></div> 
     <a class="topsquarenumber text-danger" >{{annualcount}}</a>
</div>
 
 <div class="topsquare  text-danger py-2   p-0 ">
     ANNUAL COUNT</div>
 
 </div>

</div>


<div class="col-12 mt-5" >
    <div class=" row">
    <div class="col-md-12 m-0 p-0">
 <div>
    <button (click)="toggleChart('day')">Day</button>
    <button (click)="toggleChart('week')">Week</button>
    <button (click)="toggleChart('month')">Month</button>
    <button (click)="toggleChart('year')">Year</button>
  </div>
  
 <canvas #canvas></canvas>
 
</div>
</div>
</div>